import { render, staticRenderFns } from "./UserFormAdd.vue?vue&type=template&id=22ce176a&"
import script from "./UserFormAdd.vue?vue&type=script&lang=js&"
export * from "./UserFormAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports